import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setCatNav, categorySelectedTrigger } from './../redux/actions';
import PageWrapper from './../components/PageWrapper';
import Hero from './../components/hero/Hero';
import CategoryNavWrapper from './../components/filter-pages/CategoryNavWrapper';
import MasonryGrid from './../components/filter-pages/MasonryGrid';
import { filterCategory, splitString, removeHidden } from './../scripts';

class PhotoLanding extends Component {
  componentWillMount() {
    this.props.setCatNav(this.props.staticContent.photoData.data.photo_landing_category_navigation);
    this.props.categorySelected(splitString(this.props.route));
  };
  render() {
    return (
      <PageWrapper pageId={'portfolio-landing'}>
        <Hero sliderContent={this.props.staticContent.photoData.data.hero_slider}/>
        <CategoryNavWrapper/>
        <MasonryGrid GridItems={
          filterCategory(removeHidden(this.props.staticContent.photoData.data.photo_grid),
          this.props.category)
        }/>
      </PageWrapper>
    );
  };
};

export default connect(
  state => ({
    route: state.router.location_data.pathname,
    staticContent: state.staticContent,
    category: state.current_sub_category
  }),
  dispatch => ({
    setCatNav: (navigation) => dispatch(setCatNav(navigation)),
    categorySelected: (category) => dispatch(categorySelectedTrigger(category))
  })
)(PhotoLanding);



// WEBPACK FOOTER //
// ./src/pages/PhotoLanding.js